//////// INIT GLOBAL VARS ///////



(function ($) {
  /////// INIT SCOPE VARS //////


  /////////////// ON READY /////////////////
  $(function () {
    init_mobile_menu();
    init_smooth_ancres();
    
    add_ghost_text_to_h2_titles();
  }); // end ready

  ///////////////// INIT FUNCTIONS ////////////////////
  function init_mobile_menu() {

    $(".vtx-burger-container").on("click", function(e) {
      e.stopPropagation();
      
      var $body = $("body");
      
      if( $body.hasClass("sb-active") ) {
        $body.removeClass("sb-active");
        $body.off("click");
        
      } else {
        $body.addClass("sb-active")
        
        $body.on( 'click', function(bodyEvent) {
          bodyEvent.stopPropagation();
                  
          if( ! $( bodyEvent.target ).closest( '.header__top-bar__nav' ).length ) {
            $body.removeClass("sb-active");
            $body.off("click");
          }
        });
        
      }
      
        
    });
    
  }
  
  function init_smooth_ancres() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  }

  /////////////////  FUNCTIONS /////////////////
  function add_ghost_text_to_h2_titles() {
    $(
      ".section-page-content .section-inner > h2," +
      ".block-decorated.decorated-style-1 h2"
    
    ).each(function() {
      var $this_title = $(this);
      // var title_text = escape_html( $this_title.text() );
      var title_text = $this_title.text();
      
      $this_title.addClass("ghost-text").attr("data-text", title_text).html("<span>" + title_text + "</span>");
      $this_title.wrap("<div class='heading-container'></div>");
    });
  }
  
  // function escape_html(text) {
  //   'use strict';
  //   return text.replace(/[\"&'\/<>]/g, function (a) {
  //     return {
  //       '"': '&quot;', '&': '&amp;', "'": '&#39;',
  //       '/': '&#47;',  '<': '&lt;',  '>': '&gt;'
  //     }[a];
  // });
  // }
  

})(jQuery); // end conflict sage jQuery

//////////////// GLOBAL FUNCTIONS ///////////////
function do_event_resize() {

  if (typeof(Event) === 'function') {
    var event = new Event('resize');
  } else {
    // BUGFIXE pour IE11
    var event = document.createEvent('Event');
    event.initEvent('resize', true, true);
  }

  window.dispatchEvent(event);

}